var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatasheets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 4.8V15.1946C15.4 15.6401 15.0442 16 14.6053 16H1.79472C1.35596 16 1 15.6448 1 15.2066V0.79344C1 0.364248 1.35896 0 1.80177 0H10.5974L15.4 4.8ZM13.8 5.6H9.8V1.6H2.6V14.4H13.8V5.6ZM5 4H7.4V5.6H5V4ZM5 7.2H11.4V8.8H5V7.2ZM5 10.4H11.4V12H5V10.4Z",
    fill: "#293038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasheets);
export default __webpack_public_path__ + "static/media/datasheets.0b9bc7cb3c8fffe4ba99586152e392cf.svg";
export { ForwardRef as ReactComponent };